module.exports = __webpack_public_path__ + "static/media/5_9.115c9bfe.png";